import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  FetchUserQuestionsUseCaseInput,
  FetchUserQuestionsUseCaseOutput,
  IAppErrorFactory,
  IFetchUserQuestionsUseCase,
  IQuestionBase,
  IQuestionsService,
  IUseCaseOutputFactory,
} from '../../types'

@injectable()
export default class FetchUserQuestionsInteractor implements IFetchUserQuestionsUseCase {
  @inject(symbols.IQuestionsService) private questionsService: IQuestionsService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  @inject(symbols.IUseCaseOutputFactory) private outputFactory: IUseCaseOutputFactory<{
    questions: null | IQuestionBase[]
    hasNextPage: null | boolean
  }>

  async handle(input: FetchUserQuestionsUseCaseInput): Promise<FetchUserQuestionsUseCaseOutput> {
    const output = this.outputFactory.create({
      defaultValue: {
        questions: null,
        hasNextPage: null,
      },
    })
    try {
      const { questions, hasNextPage } = await this.questionsService.fetchUserQuestions(input)
      output.data.questions = questions
      output.data.hasNextPage = hasNextPage
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }
}
